import mapStyling from './../../libraries/mapStyling';

export default class MapBlock {
    constructor(container) {
        this.container = container;
        this.map = null;
        this.marker = null;
        this.lat = null;
        this.lon = null;
        this.zoom = null;

        this.init();
    }

    init() {
        if (this.container.dataset.lat && this.container.dataset.lon) {
            this.lat = parseFloat(this.container.dataset.lat);
            this.lon = parseFloat(this.container.dataset.lon);
            this.zoom = parseFloat(this.container.dataset.zoom) || 15;

            this.map = new google.maps.Map(this.container.querySelector('.map'), {
                center: {
                    lat: this.lat,
                    lng: this.lon
                },
                zoom: this.zoom,
                draggable: false,
                styles: mapStyling,
                disableDefaultUI: true,
            });

            this.marker = new google.maps.Marker({
                map: this.map,
                position: {
                    lat: this.lat,
                    lng: this.lon
                },
                icon: {
                    url: '/img/markerBig.svg',
                    size: new google.maps.Size(44, 52),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(3, 30),
                },
            });
        }
    }
}